<template>
    <div class="form-footer-mail" id="form-footer-mail">
        <form class="form-in" v-if="formVisible" @submit="sendDataSubmit">
            <div class="form-group">
                <input type="email" name="email" class="form-control"  autocomplete="off" placeholder="Ваш E-mail" v-model="email" v-validate="{rules: { required: true, regex: regexRules.email }}">
            </div>
            <div class="btn-send">
                <button class="btn-submit btn-success" type="button" @click="sendFlatMail" :disabled="errors.any()">
                    ОК
                </button>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h4>Вы подписаны</h4>
        </div>
    </div>
</template>

<script>
    import { Validator } from 'vee-validate';
    const dict = {
        custom: {
            email: {
                required: () => 'Введите ваш E-mail'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'formMail',
        data () {
            return {
                formVisible: true,
                email: '',
                regexRules: {
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
        },
        // computed: {
        //     form () {
        //         return this.$store.state.forms
        //     }
        // },
        methods: {
            sendFlatMail() {
                var querystring = require('querystring');
                var data = {
                    'mail': this.email,
                    'from': 'Форма в подвале'
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post('/formEmail.php',querystring.stringify(data));
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLSfvDKCggwdxazcXCoZOZGX7UfuMfPBS62ymJdNcLDLp4G31LQ/formResponse",
                            data: {
                                // email
                                "entry.358336613": this.email,
                            },
                            type: "POST",
                            dataType: "xml"
                        });
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            },
            sendDataSubmit(e) {
                e.preventDefault();
                var querystring = require('querystring');
                var data = {
                    'mail': this.email,
                    'from': 'Форма в подвале'
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        axios.post('/formEmail.php',querystring.stringify(data));
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLSfvDKCggwdxazcXCoZOZGX7UfuMfPBS62ymJdNcLDLp4G31LQ/formResponse",
                            data: {
                                // email
                                "entry.358336613": this.email,
                            },
                            type: "POST",
                            dataType: "xml"
                        });
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            }
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-footer-mail.scss';
    @import '@/styles/respond/forms/form-footer-mail-respond.scss';
</style>